module.exports = __webpack_public_path__ + "img/132.5.37c98d66.png";